import React, { useState } from "react";
import {
  Box,
  Button,
  Switch,
  TextField,
  Typography,
  MenuItem,
  FormControlLabel,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "./IdeasForm.css";
import bgsky from "../../utilities/bgsky.png";

const categories = ["Design", "Feature", "Issue", "Other"];

const IdeasForm = (props) => {
  const [idea, setIdea] = useState("");
  const [category, setCategory] = useState("");
  const [anonymous, setAnonymous] = useState(false);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    const payload = {
      name: props?.user?.name,
      email: props?.user?.email,
      title,
      category,
      idea,
      anonymous,
      status: "pending",
    };

    try {
      const res = await fetch("https://hr-backend-72v1.onrender.com/sendidea", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        setTitle("");
        setCategory("");
        setIdea("");
        setAnonymous(false);
        setSuccessOpen(true);
        setTimeout(() => {
          setSuccessOpen(false);
          props.handleFormClose();
        }, 3000);
      } else {
        alert("Error: " + data.message);
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Submission failed. Sorry, but please try Again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-back">
      <div
        className="ideas-form-bg"
        style={{
          backgroundImage: `url(${bgsky})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        onClick={props.handleFormClose}
      >
        <Paper
          className="ideas-form-container"
          elevation={6}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ position: "absolute", right: 0, padding: "15px 5px" }}>
            <Button onClick={props.handleFormClose}>
              <CloseIcon />
            </Button>
          </div>

          <Typography
            variant="h5"
            fontWeight={600}
            gutterBottom
            style={{ marginLeft: "2rem", marginTop: "2rem" }}
          >
            Share Your Idea 💡
          </Typography>

          <FormControlLabel
            style={{ marginLeft: "2rem" }}
            control={
              <Switch
                checked={anonymous}
                onChange={() => setAnonymous(!anonymous)}
                color="primary"
              />
            }
            label={anonymous ? "Anonymous" : props?.user?.name}
          />
          <div
            style={{
              marginLeft: "2rem",
              marginRight: "2rem",
              marginBottom: "2rem",
            }}
          >
            <TextField
              style={{ marginLeft: "2rem", marginRight: "2rem" }}
              label="Title (3-5 Words)"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              fullWidth
              margin="normal"
            />

            <TextField
              select
              label="Category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              fullWidth
              margin="normal"
            >
              {categories.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              label="Your Idea"
              value={idea}
              onChange={(e) => setIdea(e.target.value)}
              multiline
              rows={4}
              fullWidth
              margin="normal"
            />

            <Button
              onClick={handleSubmit}
              variant="contained"
              fullWidth
              disabled={loading}
              sx={{
                mt: 2,
                backgroundColor: "#FFAD3D",
                color: "#fff",
                "&:disabled": { backgroundColor: "#ccc" },
              }}
            >
              {loading ? "Submitting..." : "Submit Idea"}
            </Button>
          </div>
        </Paper>
      </div>
      <Snackbar
        open={successOpen}
        autoHideDuration={3000}
        onClose={() => setSuccessOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          Idea submitted successfully!
        </Alert>
      </Snackbar>
    </div>
  );
};

export default IdeasForm;
